/* eslint-disable react/prop-types */
import { capitalize } from 'lodash';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import './badge.scss';

interface BadgeCardProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  /**
   * Display badge with chip
   */
  label?: string | JSX.Element | null;
  /**
   * Display badge without chip and small text
   */
  upperLabel?: string | JSX.Element | null;
  /**
   * Uppercase first letter of label
   */
  capitalizeLabel?: string | null;
  colorClass?: string;
  upperColorClass?: string;
  capitalizeColorClass?: string;
  icon?: ReactElement | null;
}

export const BadgeCard: React.FC<BadgeCardProps> = ({
  label,
  colorClass,
  upperColorClass,
  capitalizeColorClass,
  capitalizeLabel,
  upperLabel,
  icon,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <>
      {upperLabel && (
        <div
          {...props}
          className={`${upperColorClass} ${
            !upperColorClass && 'font-semibold '
          } text-base   text-neutral-12
             overflow-hidden whitespace-nowrap

           `}
        >
          <span>{upperLabel}</span>
        </div>
      )}
      {label && !icon && (
        <div
          {...props}
          className={`${colorClass}
          font-normal text-xs tracking-[0.4px] leading-4
          overflow-hidden whitespace-nowrap  rounded-full
          py-1 px-4 `}
        >
          {label}
        </div>
      )}
      {capitalizeLabel && (
        <div
          {...props}
          className={`${capitalizeColorClass} font-normal  text-xs
            overflow-hidden whitespace-nowrap  ml-4 sm:ml-0 `}
        >
          <span>{capitalize(t(capitalizeLabel))}</span>
        </div>
      )}
      {label && icon && (
        <div
          {...props}
          className={`${colorClass}
          font-normal text-xs tracking-[0.4px] leading-4 flex gap-2 items-center
          overflow-hidden whitespace-nowrap  rounded-full
          py-1 px-4 `}
        >
          {icon} {label}
        </div>
      )}
    </>
  );
};

BadgeCard.defaultProps = {
  colorClass: 'mainBlueColor',
  label: null,
  upperLabel: null,
  upperColorClass: '',
  capitalizeLabel: null,
  capitalizeColorClass: '',
};

export default BadgeCard;
